import { createBrowserRouter, Navigate, Outlet, useLocation } from "react-router";
import { useSessao } from "./api/sessao";
import { Carregando, FalhaAoCarregar } from "./components/Estados";
import { Layout } from "./components/Layout";
import { PaginaAuditoria } from "./pages/admin/Auditoria";
import { PaginaEventos } from "./pages/admin/Eventos";
import { PaginaProdutosEstoque } from "./pages/admin/ProdutosEstoque";
import { PaginaUsuarios } from "./pages/admin/Usuarios";
import { PaginaCaixa } from "./pages/Caixa";
import { PaginaDetalheCaixa } from "./pages/caixa/DetalheCaixa";
import { PaginaFecharCaixa } from "./pages/caixa/FecharCaixa";
import { PaginaFechamento } from "./pages/Fechamento";
import { PaginaLogin } from "./pages/Login";
import { PaginaPerfil } from "./pages/Perfil";
import { PaginaTrocarSenha } from "./pages/TrocarSenha";
import { PaginaVendas } from "./pages/Vendas";

/** Só deixa entrar quem está logado e já trocou a senha provisória. */
function AreaLogada() {
  const { data: sessao, isPending, error, refetch } = useSessao();
  const { pathname, search } = useLocation();
  if (isPending) return <Carregando />;
  if (error) return <FalhaAoCarregar erro={error} tentarDeNovo={() => refetch()} />;
  if (!sessao) return <Navigate to={`/login?volta=${encodeURIComponent(pathname + search)}`} replace />;
  if (sessao.usuario.deveTrocarSenha) return <Navigate to="/trocar-senha" replace />;
  return <Layout usuario={sessao.usuario} />;
}

/** A interface esconde o que não é do perfil, mas quem decide é sempre a API. */
function SoAdmin() {
  const { data: sessao } = useSessao();
  if (sessao?.usuario.perfil !== "ADMIN") return <Navigate to="/caixa" replace />;
  return <Outlet />;
}

function NaoEncontrada() {
  return <div className="vazio">Página não encontrada.</div>;
}

export const roteador = createBrowserRouter([
  { path: "/login", element: <PaginaLogin /> },
  { path: "/trocar-senha", element: <PaginaTrocarSenha /> },
  {
    element: <AreaLogada />,
    children: [
      { index: true, element: <Navigate to="/caixa" replace /> },
      { path: "caixa", element: <PaginaCaixa /> },
      { path: "caixa/fechar", element: <PaginaFecharCaixa /> },
      { path: "caixas/:id", element: <PaginaDetalheCaixa /> },
      { path: "vendas", element: <PaginaVendas /> },
      { path: "fechamento", element: <PaginaFechamento /> },
      { path: "perfil", element: <PaginaPerfil /> },
      {
        path: "admin",
        element: <SoAdmin />,
        children: [
          { path: "eventos", element: <PaginaEventos /> },
          { path: "produtos-estoque", element: <PaginaProdutosEstoque /> },
          { path: "usuarios", element: <PaginaUsuarios /> },
          { path: "auditoria", element: <PaginaAuditoria /> },
        ],
      },
      { path: "*", element: <NaoEncontrada /> },
    ],
  },
]);
